import React from 'react';
import { Zap, DollarSign, Sparkles, CheckCircle } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const ValueProposition = () => {
  const benefits = [
    {
      icon: DollarSign,
      title: 'Cost-Effective Solutions',
      description: 'Leverage AI tools and modern tech stack to deliver premium quality at competitive prices'
    },
    {
      icon: Zap,
      title: 'Rapid Development',
      description: 'AI-powered development accelerates delivery without compromising on quality'
    },
    {
      icon: Sparkles,
      title: 'Cutting-Edge AI Tech',
      description: 'Utilize latest AI tools and frameworks for websites and mobile apps'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-[#1A3E6E] to-[#1A3E6E] text-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            Build Websites & Mobile Apps Smarter
          </h2>
          <p className="text-xl text-white/90 max-w-4xl mx-auto leading-relaxed">
            We build high-quality, reliable websites and mobile apps at <span className="font-bold">low cost</span> by leveraging 
            cutting-edge <span className="font-bold">AI tech stack and tools</span>. Deliver quickly without compromising on quality.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {benefits.map((benefit, index) => {
            const IconComponent = benefit.icon;
            return (
              <Card key={index} className="bg-white/10 backdrop-blur-sm border-white/20 hover:bg-white/20 transition-all duration-300">
                <CardContent className="p-6 text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-full mb-4">
                    <IconComponent size={32} className="text-white" />
                  </div>
                  <h3 className="text-xl font-bold mb-2">{benefit.title}</h3>
                  <p className="text-white/90">{benefit.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
          <h3 className="text-2xl font-bold mb-6 text-center">What You Get</h3>
          <div className="grid md:grid-cols-2 gap-4">
            {[
              'AI-powered development workflow',
              'Modern, scalable architecture',
              'Responsive web & mobile apps',
              'Fast turnaround times',
              'High-quality, tested code',
              'Ongoing support & maintenance'
            ].map((item, index) => (
              <div key={index} className="flex items-center space-x-3">
                <CheckCircle size={20} className="text-white flex-shrink-0" />
                <span className="text-white/90">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
